import { render, staticRenderFns } from "./DetailedTileItem.vue?vue&type=template&id=11ad44c3"
import script from "./DetailedTileItem.vue?vue&type=script&lang=js"
export * from "./DetailedTileItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports